const RecipeCardGrid = () => null;

export default RecipeCardGrid;
